import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { GenericMenuComponent } from "../generic-menu-component.model";
import { MenuItem } from "../menu-item.model";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent extends GenericMenuComponent {
  @Input() items: MenuItem[] = [];
}
